import React, { Component } from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import useCompleoForm from "customHooks/useCompleoReactHookForm";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoReactHookForm/helpers/Loading";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import { useApi } from "customHooks/useApi";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";
import useEmailTemplate from "../../customHooks/useCompleoReactHookForm/Inputs/EmailDataV2/useEmailTemplate";

const EmailTemplateNew = (props: any) => {
    const cancelFunction = useCancelButtonForm("/emailtemplate/list");
    // const [addProps, setAddProps] = React.useState<
    //     Compleo.useCompleoForm.AdditionalPropertiesField[]
    // >([]);
    const moduleName = "EMAILTEMPLATENEW";
    const [t, i18n, readyTranslation] = useTranslation(moduleName, {
        useSuspense: false
    });
    const postAddress = `/emailtemplate/new`;

    const [addDataReturn, addData] = useApi(postAddress, "post");
    const [metadata] = useGetMetadata(moduleName);
    const [valuesFromSource] = useValuesFromSource(metadata, true, {});
    valuesFromSource.deleted = false;
    valuesFromSource.type = props.type;

    const addProps: Compleo.useCompleoForm.AdditionalPropertiesField[] = [
        { fieldName: "template", props: { type: props.type } }
    ];

    const [formCompleo, finished] = useCompleoForm({
        t,
        ready: readyTranslation,
        i18nV: i18n,
        postMethod: addData,
        postReturn: addDataReturn,
        redirectAddress: "/emailtemplate/list",
        FormType: FormClassic,
        metadadosRetorno: metadata,
        valuesFromSource,
        secondaryButtonFunction: cancelFunction,
        additionalFieldProperties: addProps
    });

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;

    // addProps

    const ready = finished && readyTranslation;
    const featureMainDescription = `${t("a_FeatureMainDescription")} - ${t(
        `typeEmail_${props.type}`
    )}`;
    if (ready) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={featureMainDescription}
                // featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="md"
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default EmailTemplateNew;
